import QuadPack from './components/QuadPack.vue'
// LOS QUTIAMOS DE AQUI, hay que importarlos con from "puig-quad-pack/SillageQuadPack"
// import SillageQuadPack from './components/SillageQuadPack.vue'
// import AudioQuadPack from './components/AudioQuadPack.vue'
import { createCanvas } from './utils/createCanvas'
import { quadrificationJson } from './utils/quadrificationJson'
export { QuadPack, quadrificationJson, createCanvas }
export default QuadPack
